/* eslint-disable prefer-arrow-callback */
/* eslint-disable import/prefer-default-export */
export function ScrollUp(buttonId, formId) {
  $(buttonId).on('click', function () {
    $(formId).parsley().validate('details-about-car');

    if ($('.field_with_errors').length) {
      const scrollTop = window.innerWidth > 576 ? 450 : 150;

      window.setTimeout(function () {
        $('html, body').animate({
          scrollTop: $('.field_with_errors:first').offset().top - scrollTop,
        }, 1000);
      }, 4);
    }
  });
}



// WEBPACK FOOTER //
// ./app/webpacker/src/js/form_scroll_up.js